import {
  BibliographyRealReserveGroup,
  BibliographyRealReserveGroupFromJSON,
  BibliographyRealReserveSet,
  BibliographyRealReserveSetFromJSON,
  exists
} from '@/api'

export interface BibliographyRealReserveSetGroup {
  reserveSets: BibliographyRealReserveSet[]
  reserveGroups: BibliographyRealReserveGroup[]
}

export const defaultBibliographyRealReserveSetGroup = (): BibliographyRealReserveSetGroup => ({
  reserveSets: [],
  reserveGroups: []
})

export function BibliographyRealReserveSetGroupFromJSON(
  json: any
): BibliographyRealReserveSetGroup {
  return {
    reserveSets: exists(json, 'reserve_sets')
      ? json.reserve_sets.map(BibliographyRealReserveSetFromJSON)
      : [],
    reserveGroups: exists(json, 'reserve_groups')
      ? json.reserve_groups.map(BibliographyRealReserveGroupFromJSON)
      : []
  }
}
